// @flow
import React from 'react';
import {Link} from '@homeaway/react-localization-components';
import Experiment, {On, Off} from '@homeaway/react-experiment';
import {VrboPriceSummary} from '@homeaway/react-price-summary';

import {VRBO_TOTAL_PRICE_POSA_PRICE_SUMMARY} from '../../abacus/experiments';
import {DualPrice} from '../DualPrice/DualPrice';
import RoomsBedsDetails from './Details/RoomsBedsDetails/RoomsBedsDetails';
import PropertyDetails from './Details/PropertyDetails/PropertyDetails';
import {SuperlativeBadge, NewListingBadge, RankedBadges} from './Badges/Badges';
import WebRatingBadge from '../WebRatingBadge/WebRatingBadge';
import ColorizedRating from '../Rating/ColorizedRating/ColorizedRating';

import type {Props as HitInfoProps} from './HitInfo';

// TODO: move minStay logic to lingua
// https://jira.homeawaycorp.com/browse/SERP-2848
export default function HitInfoMobile({
    intl,
    listing,
    onClick,
    isModalOpen,
    setModalOpen
}: HitInfoProps) {
    const superlativesBadges = listing.superlativesBadges || [];
    const rankedBadges = listing.rankedBadges || [];
    const webRatingBadges = listing.webRatingBadges || [];
    const showWebRatingBadge =
        listing.reviewCount === 0 && webRatingBadges && webRatingBadges.length;

    const DualPriceWrapper = () => {
        return (
            <div className="HitInfo__priceSuperlativeGroup">
                <Experiment name={VRBO_TOTAL_PRICE_POSA_PRICE_SUMMARY}>
                    <On>
                        <div className="HitInfo__priceSummary">
                            <VrboPriceSummary
                                {...listing.prices}
                                mainPrice="total"
                                priceAlign="left"
                            />
                        </div>
                    </On>
                    <Off>
                        <DualPrice
                            listing={listing}
                            intl={intl}
                            isDesktop={false}
                            showInstantBookIcon={false}
                            withTooltip
                            isModalOpen={isModalOpen}
                            setModalOpen={setModalOpen}
                        />
                    </Off>
                </Experiment>
                <SuperlativeBadge superlativesBadges={superlativesBadges} />
                <NewListingBadge superlativesBadges={superlativesBadges} />
            </div>
        );
    };

    return (
        <div className="HitInfo__content">
            <Link
                target={'_blank'}
                className="media-flex__content"
                href={listing.detailPageUrl}
                onClick={onClick}
                tabIndex="0"
            >
                <div className="HitInfo__starRating">
                    {showWebRatingBadge ? (
                        <WebRatingBadge
                            badge={webRatingBadges[0]}
                            renderStarIcon
                        />
                    ) : (
                        <ColorizedRating listing={listing} />
                    )}
                    <RankedBadges rankedBadges={rankedBadges} />
                </div>
                <PropertyDetails listing={listing} />
                <RoomsBedsDetails listing={listing} />
                <div className="media-flex__left">
                    <DualPriceWrapper />
                </div>
            </Link>
        </div>
    );
}
